import * as React from 'react';
import { analyticsTracker } from 'uitk-react-utils';
import { PlayerStates } from './types.esm.js';

var useVideoHook = function (analytics) {
    var _a = React.useState({ status: false, data: 0 }), playerError = _a[0], setPlayerError = _a[1];
    var _b = React.useState(false), isPlayerReady = _b[0], setIsPlayerReady = _b[1];
    var _c = React.useState(PlayerStates.get('unstarted')), playerState = _c[0], setPlayerState = _c[1];
    var _d = React.useState(), player = _d[0], setPlayer = _d[1];
    var onPlayerError = function (event) {
        setPlayerError({ status: true, data: event.data });
    };
    var onPlayerReady = function (event) {
        setIsPlayerReady(true);
        setPlayerState(event.target.getPlayerState());
    };
    var onPlayerStateChange = function (event) {
        setPlayerState(event.data);
    };
    var onClickPlay = function () {
        if (typeof player !== 'undefined') {
            // @ts-ignore
            player.playVideo();
        }
        if (analytics) {
            analyticsTracker(analytics, 'playVideo', '');
        }
    };
    var onClickPause = function () {
        if (typeof player !== 'undefined') {
            // @ts-ignore
            player.pauseVideo();
        }
        if (analytics) {
            analyticsTracker(analytics, 'pauseVideo', '');
        }
    };
    return {
        playerError: playerError,
        onPlayerError: onPlayerError,
        isPlayerReady: isPlayerReady,
        onPlayerReady: onPlayerReady,
        playerState: playerState,
        onPlayerStateChange: onPlayerStateChange,
        player: player,
        setPlayer: setPlayer,
        onClickPlay: onClickPlay,
        onClickPause: onClickPause
    };
};

export { useVideoHook };
